import React from 'react';

const MenuBanner = ({ children }) => <div>{children}</div>;
export default MenuBanner;
